import { TemplateDetail, TemplateListItem } from '../models';

export type TemplateStatus = 'unavailable' | 'switched-off' | 'custom' | 'default';

export const STATUS_LABELS: Record<TemplateStatus, string> = {
    'unavailable': 'Platform template no longer available',
    'switched-off': 'My version (switched off)',
    'custom': 'Using my version',
    'default': 'Using platform default',
};

export function listItemStatus(item: TemplateListItem): TemplateStatus {
    if (!item.defaultAvailable) {
        return 'unavailable';
    }
    if (item.isCustomized && !item.isCustomActive) {
        return 'switched-off';
    }
    return item.effectiveSource === 'custom' ? 'custom' : 'default';
}

export function detailStatus(detail: TemplateDetail): TemplateStatus {
    if (!detail.defaultAvailable) {
        return 'unavailable';
    }
    if (detail.custom && !detail.custom.isActive) {
        return 'switched-off';
    }
    return detail.effectiveSource === 'custom' ? 'custom' : 'default';
}
